/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import S from './OccupancyCountsAttributeRenderer.css'

export default {
  objectType : 'room',
  attrName : 'room.occupancyCounts',
  renderer : ( data ) => {
    const { data : rawData } = JSON.parse( data )

    const counts = Object
      .values( rawData.occupancy )
      .reduce(
        ( acc, curr ) => {
          acc.dog += curr.counts.dog ?? 0
          acc.person += curr.counts.person ?? 0

          return acc
        },
        { dog : 0, person : 0 },
      )

    return (
      <div style={{ width : '100%' }}>
        <div>
          <small>Occupancy</small>
        </div>
        <div>
          <div className={S.counts}>
            <i className="fa-solid fa-dog" />
            <span>{counts.dog}</span>
            <div className={S.separator} />
            <i className="fa-solid fa-user-group" />
            <span>{counts.person}</span>
          </div>
        </div>
      </div>
    )
  },
}
